import { SegmentConstants } from './Segment.constants';

const initialState = {
  appliedFilters: {
    type: '',
    pageNumber: '1',
    pageSize: '10',
    isSummaryRequired: 'true'
  },
  segment: {
    loading: false,
    error: false
  },
  categoryFilters: {
    loading: false,
    error: false
  },
  createRequest: {
    creating: false,
    error: false
  },
  userCount: {
    loading: false,
    error: false
  },
  segmentList: {},
  segmentDetails: {},
  searchResult: {}
};

// --- Reducer function to set applied filters
const appliedFiltersReducer = (state = initialState.appliedFilters, action) => {
  if (action.filterType === SegmentConstants.RESET_APPLIED_FILTERS) {
    return initialState.appliedFilters;
  }
  return { ...state, [action.filterType]: action.payload };
};

const SegmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case SegmentConstants.APPLIED_FILTERS:
      const appliedFilters = appliedFiltersReducer(state.appliedFilters, action);
      return {
        ...state,
        segment: {},
        appliedFilters
      };

    // --- Get Segments clause values ---
    case SegmentConstants.GET_SEGMENT_REQUEST:
      return {
        ...state,
        segment: {
          loading: true,
          error: false
        }
      };

    case SegmentConstants.GET_SEGMENT_SUCCESS:
      return {
        ...state,
        segment: {
          data: action.payload,
          loading: false,
          error: false
        }
      };

    case SegmentConstants.GET_SEGMENT_ERROR:
      return {
        ...state,
        segment: {
          loading: false,
          error: true
        }
      };

    // --- Get Segments clause values ---
    case SegmentConstants.GET_SEGMENT_LIST_REQUEST:
      return {
        ...state,
        segmentList: {
          loading: true,
          error: false
        }
      };

    case SegmentConstants.GET_SEGMENT_LIST_SUCCESS:
      return {
        ...state,
        segmentList: {
          ...action.payload,
          loading: false,
          error: false
        }
      };

    case SegmentConstants.GET_SEGMENT_LIST_ERROR:
      return {
        ...state,
        segmentList: {
          loading: false,
          error: true
        }
      };

    case SegmentConstants.GET_CATEGORY_REQUEST:
      return {
        ...state,
        clauseValues: {
          loading: true,
          error: false
        }
      };

    case SegmentConstants.GET_CATEGORY_SUCCESS:
      return {
        ...state,
        clauseValues: {
          data: action.payload,
          loading: false,
          error: false
        }
      };

    case SegmentConstants.GET_CATEGORY_ERROR:
      return {
        ...state,
        clauseValues: {
          loading: false,
          error: true
        }
      };

    // --- Create segment request ---
    case SegmentConstants.CREATE_SEGMENT_REQUEST:
      return {
        ...state,
        createRequest: {
          creating: true,
          error: false
        }
      };

    case SegmentConstants.CREATE_SEGMENT_SUCCESS:
      return {
        ...state,
        createRequest: {
          creating: false,
          error: false
        }
      };

    case SegmentConstants.CREATE_SEGMENT_ERROR:
      return {
        ...state,
        createRequest: {
          creating: false,
          error: true
        }
      };

    case SegmentConstants.GET_USER_COUNT_REQUEST:
      return {
        ...state,
        userCount: {
          loading: true,
          error: false
        }
      };

    case SegmentConstants.GET_USER_COUNT_SUCESS:
      return {
        ...state,
        userCount: {
          data: action.payload,
          loading: false,
          error: false
        }
      };

    case SegmentConstants.GET_USER_COUNT_ERROR:
      return {
        ...state,
        userCount: {
          loading: false,
          error: true
        }
      };

    // --- Get Segments details ---
    case SegmentConstants.GET_SEGMENT_DETAILS_REQUEST:
      return {
        ...state,
        segmentDetails: {
          loading: true,
          error: false
        }
      };

    case SegmentConstants.GET_SEGMENT_DETAILS_SUCCESS:
      return {
        ...state,
        segmentDetails: {
          ...action.payload,
          loading: false,
          error: false
        }
      };

    case SegmentConstants.GET_SEGMENT_DETAILS_ERROR:
      return {
        ...state,
        segmentDetails: {
          loading: false,
          error: true
        }
      };

    // --- Search segment request ---
    case SegmentConstants.GET_SEARCH_SEGMENT_REQUEST:
      return {
        ...state,
        searchResult: {
          loading: true,
          error: false
        }
      };

    case SegmentConstants.GET_SEARCH_SEGMENT_SUCCESS:
      return {
        ...state,
        searchResult: {
          loading: false,
          error: false,
          list: action.payload
        }
      };

    case SegmentConstants.GET_SEARCH_SEGMENT_ERROR:
      return {
        ...state,
        searchResult: {
          loading: false,
          error: true
        }
      };

    default:
      return state;
  }
};

export default SegmentReducer;
